import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {ProjectTeamEditDialog} from '@/features/projects/components/project-team-edit-dialog/ProjectTeamEditDialog'
import {useState} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon, UserCheck01Icon, UserLeft01Icon} from '@/components/ui/icon/Icon'
import {
    StyledDetailsFieldsSection,
    StyledTeamButton
} from '@/features/projects/components/project-details-team-section/style'
import {useTheme} from 'styled-components'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {RegularTeamBody} from '@/features/projects/components/regular-team-body/RegularTeamBody'
import {ReserveTeamBody} from '@/features/projects/components/reserve-team-body/ReserveTeamBody'

export const ProjectDetailsTeamSection = () => {
    const {t} = useTranslation()
    const {project, isEditable} = useOutletContext<{project: ProjectExtended; isEditable: boolean}>()

    const [isAReserve, setIsAReserve] = useState(false)
    const {palette} = useTheme()

    return (
        <StyledDetailsFieldsSection
            variant="primary"
            title={t('projects:rehabilitation_team')}
            infoTitleSlot={
                project.missingGroups.length > 0 && (
                    <Tooltip variant="light" content={t('projects:rehabilitation_team_tooltip')}>
                        <AlertCircleIcon size={18} color={palette.warning[500]} />
                    </Tooltip>
                )
            }
            headingEndSlot={
                <Flexbox gap={2}>
                    {project.team.length > 1 && (
                        <>
                            <StyledTeamButton
                                size="sm"
                                onClick={() => setIsAReserve(false)}
                                variant={'ghost'}
                                $isActive={!isAReserve}
                            >
                                <UserCheck01Icon />
                                {t('projects:team_specialist')}
                            </StyledTeamButton>

                            <StyledTeamButton
                                size="sm"
                                onClick={() => setIsAReserve(true)}
                                variant={'ghost'}
                                $isActive={isAReserve}
                            >
                                <UserLeft01Icon />
                                {t('projects:team_reserve')}
                            </StyledTeamButton>
                        </>
                    )}

                    {isEditable || (isAReserve && project.status == 'open') ? (
                        <ProjectTeamEditDialog project={project} isAReserve={isAReserve} />
                    ) : null}
                </Flexbox>
            }
        >
            {isAReserve ? <ReserveTeamBody team={project.team} /> : <RegularTeamBody team={project.team} />}
        </StyledDetailsFieldsSection>
    )
}
